import React, { useState } from "react";
import { apiFetch } from "../../lib/api";

const DiscogsFetcher = ({ onFetch }) => {
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractReleaseIdFromUrl = (url) => {
    const match = url.match(/discogs\.com\/release\/(\d+)/); // ✅ proper regex
    return match ? match[1] : url;
  };

  const fetchDiscogsData = async () => {
    const releaseId = extractReleaseIdFromUrl(url);
    if (!releaseId) {
      setError("Invalid Discogs URL");
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const res = await apiFetch(`/api/discogs?urlOrId=${releaseId}`);

      if (!res.ok) throw new Error("Fetch failed");

      const data = await res.json();
      onFetch(data);
    } catch (err) {
      console.error("Discogs fetch error:", err);
      setError("Failed to fetch Discogs data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex space-x-3">
        <input
          type="text"
          className="w-full px-4 py-3 rounded-md bg-black text-white border border-zinc-700 placeholder-zinc-500"
          placeholder="Paste Discogs release URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <button
          onClick={fetchDiscogsData}
          className="px-6 py-2 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-md shadow-sm transition"
          disabled={loading}
        >
          {loading ? "Fetching..." : "Fetch"}
        </button>
      </div>
      {error && <p className="text-red-400 text-sm">{error}</p>}
    </div>
  );
};

export default DiscogsFetcher;
